import Api from '@/api/api.js'
import ApiStock from '@/api/stock/api_stock'
import ApiFinance from '@/api/finances/_api_finance'

// Exclusions après la durée de couverture (04/10/2026), déplacées de Caisse › Paramètres › Exclusions :
// mêmes données (be_caisse cca_custom_exclusions) et mêmes listes de prestations (mêmes identifiants).
export default {
    liste() {
        return ApiFinance().get('/custom-exclusions/liste').then(response => response.data)
    },
    enregistrer(data) {
        return ApiFinance().post('/custom-exclusions/store', data).then(response => response.data)
    },
    analyses() {
        return Api().get('categories_analyses').then(response => response.data)
    },
    examens() {
        return Api().get('/type_examens').then(response => response.data)
    },
    medicaments() {
        return ApiStock().get('/medicaments/liste-ordonne').then(response => response.data)
    },
    consommables() {
        return ApiStock().get('/consommables/liste-all-consumable').then(response => response.data)
    },
    chirurgies() {
        return Api().get('/config/chirurgies').then(response => response.data)
    },
    bilansSante() {
        return Api().get('/bilan-sante/liste').then(response => response.data)
    },
    actes() {
        return Api().get('/prestations/actes/acte').then(response => response.data)
    },
    typesAdmission(data_type) {
        return Api().post('/assurances/tarification/type-admission', { assurance_id: 0, data_type }).then(response => response.data)
    },
}
